module.exports = __webpack_public_path__ + "static/media/jilu.9e2479f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jilu.jpg
// module id = 191
// module chunks = 0